/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { tableStateSelector } from '../../redux/selectors/tables';
import { ITableColumn } from '../../types/layout/table';

export interface ITableColumnFilterComponentProps {
    onChange?: (value: any) => void;
    value?: any;
}

export interface ITableColumnFilterProps {
    column: ITableColumn;
    onFilter: Function;
    tableName: string;
}

function TableColumnFilter({
    children, column, onFilter, tableName,
}: React.PropsWithChildren<ITableColumnFilterProps>) {
    const [contentVisible, setContentVisible] = useState(false);
    const [filterValue, setFilterValue] = useState<any>();
    const tableState = useSelector(tableStateSelector(tableName));

    const filtered = tableState?.filters?.[column.dataIndex] instanceof Object;

    /**
     * Обработка нажатия на кнопку "Применить"
     */
    const onApplyClick = () => {
        setContentVisible(false);
        onFilter(filterValue);
    };

    /**
     * Обработка нажатия на кнопку "Отмена"
     */
    const onCancelClick = () => {
        setContentVisible(false);
        onFilter(undefined);
        setFilterValue(undefined);
    };

    /**
     * Обработка нажатия на кнопку "Фильтр"
     * @param e - event
     */
    const onFilterButtonClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        setContentVisible(!contentVisible);
    };

    /**
     * Отмена родительский событий на клик
     * @param e - event
     */
    const stopPropagation: React.MouseEventHandler<HTMLDivElement> = (e) => {
        e.stopPropagation();
    };

    /**
     * Обработка изменения значения фильтра
     * @param value - значение фильтра
     */
    const onFilterValueChange = (value: any) => setFilterValue(value);

    /**
     * Отрисовать эл-т фильтра
     */
    const renderChildren = () => {
        if (React.isValidElement(children)) {
            return React.cloneElement(children, {
                onChange: onFilterValueChange,
                value: filterValue,
            } as any);
        }
        return null;
    };

    return (
        <div className={`dropdown${contentVisible ? ' show' : ''}`} style={{ float: 'right', height: 24, width: 24 }}>
            <button type="button" className={`btn btn-xs float-right btn-outline-dark${filtered ? ' bg-primary' : ''}`} onClick={onFilterButtonClick}>
                <i className="fa fa-filter" />
            </button>
            <div
                className={`dropdown-menu p-2${contentVisible ? ' show' : ''}`}
                onClick={stopPropagation}
                hidden={!contentVisible}
                role="contentinfo"
                style={{ minWidth: contentVisible ? 240 : undefined }}
            >
                <button type="button" className="btn float-right btn-link pt-0 pr-1" onClick={() => setContentVisible(false)}>
                    <i className="fa fa-close" />
                </button>
                {renderChildren()}
                <button className="btn-sm btn-danger float-right mt-2 ml-2" type="button" onClick={onCancelClick}>Отмена</button>
                <button className="btn-sm btn-primary float-right mt-2" type="button" onClick={onApplyClick}>Применить</button>
            </div>
        </div>
    );
}

export default TableColumnFilter;
